
import { fetchJSONWithAuth } from "./hikoFetch";

/**
 * 
 * @param {object} mahiContext 
 * @param {object} abortSignal object from AbortSignal browser API
 * @param {string} icpNumber 15 digit ICP Number 
 * @returns {object[]} list of work order objects
 */
export async function getLiveningWorkOrdersbyICP(mahiContext, abortSignal, icpNumber) {
    console.log('getLiveningWorkOrdersbyICP', icpNumber);
    const options = {
        method: 'GET',
        headers: {
        },
    };
    const bffPath = `/bff/icp-livening-service/api/new-connections/livening-work-orders-by-icp/${icpNumber}`;
    const queryParams = {
    }
    const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options, abortSignal);
    console.log('getLiveningWorkOrdersbyICP response', response);
    return response;
}

/**
 * 
 * @param {object} mahiContext 
 * @param {string} workOrderId E.g. 00014089
 * @param {any} abortSignal 
 * @returns {object} work order details
 */
export async function getWorkOrderDetails(mahiContext, workOrderId, abortSignal) {
    console.log('getWorkOrderDetails', workOrderId);
    const options = {
        method: 'GET',
        headers: {
        },
    };
    const bffPath = `/bff/icp-livening-service/api/new-connections/get-livening-work-order/${workOrderId}`;
    const queryParams = {
    }
    const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options, abortSignal);
    console.log('getWorkOrderDetails response', response);
    return response;
}

/**
 * 
 * @param {object} mahiContext 
 * @param {object} inspectionData e.g. {
 *    "icpNumber": "0000571486NRE5C",
 *    "workOrderNumber": "00017684",
 *    "meterBoardLocation": {
 *        "latitude": -35.6492528,
 *        "longitude": 174.2781868
 *    },
 *    "meterBoardLocationDesc": "on the far side of the house",
 *    "connectionDate": "2022-06-09T14:55:00+12:00",
 *    "phase": {
 *        "red": true,
 *        "white": false,
 *        "blue": false
 *    },
 *    "rippleControllerPhase": {
 *        "red": true,
 *        "white": false,
 *        "blue": false
 *    },
 *    "fuseRating": 32,
 *    "connectionPoint": "Pillar",
 *    "connectionType": "Underground",
 *    "isLoopImpedanceOK": true,
 *    "isPhaseRotationOK": true,
 *    "comments": "poor impedance"
 * }
 * 
 * @returns 
 */
export async function postLiveningForm(mahiContext, inspectionData) {
    console.log('postLiveningForm', inspectionData);
    const options = {
        method: 'POST',
        headers: {
        },
        body: JSON.stringify(inspectionData),
    };
    const bffPath = `/bff/icp-livening-service/api/new-connections/submit-livening-form`;
    const queryParams = {
    }
    const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options);
    console.log('postLiveningForm response', response);
    return response;
}



/**
 * 
 * @param {object} mahiContext 
 * @param {string} virtualStatus E.g. 'Ready', 'Inspected Recently'
 * @returns {object[]} list of work order objects
 */
export async function getIcpInspections(mahiContext, virtualStatus, abortSignal) {
    
    console.log('getIcpInspections virtualStatus', virtualStatus);

    if (!virtualStatus) {
        throw new Error('Virtual status required to get ICP inspections');
    }
    const options = {
        method: 'GET',
        headers: {
        },
    };
    const bffPath = `/bff/icp-livening-service/api/new-connections/get-livening-work-orders-by-status/${encodeURIComponent(virtualStatus)}`;
    const queryParams = {
    }
    const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options, abortSignal);
    console.log('getIcpInspections response', response);
    return response;
}

export async function postUpdateWorkOrderStatus(mahiContext, workOrderId, workOrderStatus, onHoldReason, scheduledDate) {
    console.log('postUpdateWorkOrderStatus workOrderId, workOrderStatus, onHoldReason', workOrderId, workOrderStatus, onHoldReason, scheduledDate)
    const options = {
        method: 'POST',
        headers: {
        },
        body: JSON.stringify({workOrderStatus, onHoldReason, scheduledDate}),
    };
    const bffPath = `/bff/icp-livening-service/api/new-connections/update-livening-work-order-status/${workOrderId}`;
    const queryParams = {
    }
    const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options);
    console.log('postUpdateWorkOrderStatus response', response);
    return response;
}


/**
 * 
 * @param {object} mahiContext 
 * @param {string} workOrderStatus E.g. On Hold With Contractor
 * @param {any} abortSignal 
 * @returns {onHoldReasons: ["one","two","three"]} on hold reasons list
 */
export async function getWorkOrderOnHoldReasons(mahiContext, workOrderStatus, abortSignal) {
    console.log('getWorkOrderOnHoldReasons', workOrderStatus)
    const options = {
        method: 'GET',
        headers: {
        },
    };
    const bffPath = `/bff/icp-livening-service/api/new-connections/get-work-order-on-hold-reasons`
    const queryParams = {
        workOrderStatus,
    }
    const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options, abortSignal)
    console.log('getWorkOrderOnHoldReasons response', response)
    return response
}